export default "__VITE_ASSET__bde50ba8__"